import { UserMfaAuthenticator } from '../../../../models/User/mfa/user-mfa-configuration/user-mfa-authenticator';

export class MfaSelectCardViewModel {
	// authenticator data
	public UserMfa: UserMfaAuthenticator;

	// visual information
	public MfaInfoIconUrl: string;
	public MfaTypeTitle: string;
	public MfaTypeDescription: string;
}
